export var ENTER = 'ENTER';
export var UPDATE = 'UPDATE';
export var LEAVE = 'LEAVE';